// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Caml_string from "melange.js/caml_string.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function compact(param) {
  return window.innerWidth < 640;
}

function pathname(param) {
  return window.location.pathname;
}

function push(path) {
  window.history.pushState(null, "", path);
}

function nanoid(param) {
  const bytes = crypto.getRandomValues(new Uint8Array(21));
  return Stdlib__String.init(21, (function (index) {
    return Caml_string.get("_-0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ", bytes[index] & 63);
  }));
}

function response_result(promise) {
  return promise.then(function (response) {
    return response.json().then(function (body) {
      const status = response.status;
      let tmp;
      let exit = 0;
      if (status >= 203) {
        switch (status) {
          case 401 :
            tmp = {
              TAG: /* Error */ 1,
              _0: /* Unauthorized */ 0
            };
            break;
          case 403 :
            tmp = {
              TAG: /* Error */ 1,
              _0: /* Forbidden */ 1
            };
            break;
          case 404 :
            tmp = {
              TAG: /* Error */ 1,
              _0: {
                TAG: /* Missing */ 0,
                _0: Stdlib__Option.value(Js__Js_json.decodeString(Mapre_wire__Json.get(body, "error")), "not_found")
              }
            };
            break;
          default:
            exit = 1;
        }
      } else if (status >= 200) {
        tmp = {
          TAG: /* Ok */ 0,
          _0: body
        };
      } else {
        exit = 1;
      }
      if (exit === 1) {
        tmp = {
          TAG: /* Error */ 1,
          _0: {
            TAG: /* Failed */ 1,
            _0: Stdlib__Option.value(Js__Js_json.decodeString(Mapre_wire__Json.get(body, "error")), "request_failed")
          }
        };
      }
      return Promise.resolve(tmp);
    });
  }).catch(function (param) {
    return Promise.resolve({
      TAG: /* Error */ 1,
      _0: {
        TAG: /* Failed */ 1,
        _0: "Connection unavailable. Retry when online."
      }
    });
  });
}

function request(controller, method_, body, path) {
  const headers = Js__Js_dict.fromList({
    hd: [
      "Content-Type",
      "application/json"
    ],
    tl: /* [] */ 0
  });
  let tmp = {
    method: Stdlib__Option.value(method_, body === undefined ? "GET" : "POST"),
    credentials: "same-origin",
    signal: controller.signal,
    headers
  };
  if (body !== undefined) {
    tmp.body = Caml_option.valFromOption(body);
  }
  const opts = tmp;
  return response_result(fetch(path, opts));
}

function upload(controller, headers, file, path) {
  return response_result(fetch(path, {
    method: "POST",
    credentials: "same-origin",
    signal: controller.signal,
    headers: Js__Js_dict.fromList(headers),
    body: file
  }));
}

function copy_text(text) {
  navigator.clipboard.writeText(text);
}

function on_escape(emit) {
  window.addEventListener("keydown", (function ($$event) {
    if ($$event.key === "Escape") {
      return Curry._1(emit, undefined);
    }
    
  }));
}

function utf8_size(text) {
  return new TextEncoder().encode(text).byteLength;
}

function controller(prim) {
  return new AbortController();
}

function abort(prim) {
  prim.abort();
}

function socket(prim) {
  return new WebSocket(prim);
}

function close(prim) {
  prim.close();
}

function send(prim0, prim1) {
  prim0.send(prim1);
}

function ready(prim) {
  return prim.readyState;
}

function on_open(prim0, prim1) {
  prim0.onopen = prim1;
}

function on_message(prim0, prim1) {
  prim0.onmessage = prim1;
}

function on_close(prim0, prim1) {
  prim0.onclose = prim1;
}

function data(prim) {
  return prim.data;
}

function code(prim) {
  return prim.code;
}

const origin = window.location.origin;

function listen(prim0, prim1) {
  window.addEventListener(prim0, prim1);
}

function uuid(prim) {
  return crypto.randomUUID();
}

function later(prim0, prim1) {
  return setTimeout(prim0, prim1);
}

function cancel(prim) {
  clearTimeout(prim);
}

export {
  controller,
  abort,
  request,
  upload,
  socket,
  close,
  send,
  ready,
  on_open,
  on_message,
  on_close,
  data,
  code,
  origin,
  pathname,
  compact,
  push,
  listen,
  uuid,
  nanoid,
  utf8_size,
  later,
  cancel,
  copy_text,
  on_escape,
}
/* origin Not a pure module */
